module.exports = __webpack_public_path__ + "img/113.fb8079c7.jpg";